<template>
  <section id="yellow-header" class="w-100 bg-purple py-2">
    <div class="box-backdrop" :class="backdropControl" @click="closeAnimateBox()" />

    <b-container fluid class="pr-3">
      <b-row class="d-flex align-items-center justify-content-between">
        <!-- logotipo -->
        <b-col lg="2" md="4" cols="4">
          <router-link to="/">
            <img :src="require(`@/assets/images/logo-white.png`)" :width="widthLogo" />
          </router-link>
        </b-col>

        <!-- menu high device -->
        <b-col id="menu-high-device" class="d-flex justify-content-end">
          <div
            v-for="(item, i) in menu"
            :key="item.id"
            :class="heightMenu + ' ' + item.styleButton"
          >
            <router-link
              v-if="item.route"
              :to="item.pathTo"
              v-show="!item.disabled"
              v-html="item.title"
              class="text-uppercase px-3 menu-links"
              :class="item.styleButton"
              :style="fontSizeMenu"
            />

            <a
              v-if="!item.route"
              @click="animateBox(i)"
              v-show="!item.disabled"
              v-html="item.title"
              class="text-uppercase px-3 menu-links-important"
              style="cursor: pointer;"
              :class="item.styleButton"
              :style="fontSizeMenu"
            />

            <div
              :id="`float-box-${i}`"
              class="bg-white rounded shadow-lg p-4 position-absolute mt-3 text-uppercase flex-column float-box"
              :class="item.controlBox"
              v-if="!item.route"
            >
              <a
                :href="item.zapPath"
                target="_blank"
                class="text-dark mb-3"
                style="font-size: .9rem;"
              >
                <i class="fa fa-whatsapp mr-2"></i>Maringá-PR: (44) 3305-1980
              </a>
              <a :href="item.pathTo" target="_blank" class="text-dark" style="font-size: .9rem;">
                <i class="fa fa-whatsapp mr-2"></i>Curitiba-PR: (41) 3532-1509
              </a>
            </div>
          </div>
        </b-col>

        <!-- open -->
        <!-- menu low device -->
        <b-col id="menu-low-device" class="flex-row-reverse">
          <!-- menu hamburguer -->
          <div
            class="container-nav-icon"
            :class="{ 'z-index-icon': isOpen, 'position-fixed': isOpen }"
            style="transform: scale(.45);"
          >
            <div id="nav-icon" @click="isOpen = !isOpen" :class="{ 'open': isOpen }">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </b-col>

        <!-- container menu low device -->
        <div
          class="bg-purple container-menu-low-device d-flex p-4"
          :class="{ 'p-left-0': isOpen }"
          style="overflow-y: auto"
        >
          <!-- menu list -->
          <div class="d-flex flex-column">
            <!-- menu link at home -->
            <router-link to="/" class="mb-5" v-on:click.native="isOpen = !isOpen">
              <img :src="require(`@/assets/images/logo-white.png`)" width="200" />
            </router-link>

            <!-- menu link geral -->
            <div v-for="item in organizeMenu" :key="item.id" :class="item.route ? 'mb-3' : ''">
              <a
                v-show="(item.route) && (item.id_t === 1 || item.id_t === 2)"
                @click="animateBoxMobile(item.id_t)"
                v-html="item.title"
                class="text-uppercase font-weight-normal text-nowrap rounded-pill text-purple bg-orange py-2 px-4"
                style="font-size: 105%;"
              />

              <router-link
                v-show="(item.route) && (item.id_t !== 1 && item.id_t !== 2)"
                :to="item.pathTo"
                v-html="item.title"
                class="text-uppercase text-yellow font-weight-normal"
                style="font-size: 135%;"
                v-on:click.native="isOpen = !isOpen"
              />

              <div
                :id="`float-box-mobile-${item.id_t}`"
                class="bg-white rounded shadow-lg p-4 ml-3 position-absolute text-uppercase flex-column float-box"
                :class="item.controlBox"
                v-if="item.controlBox !== 'd-none' && item.controlBox !== ''"
                v-click-outside="hide"
              >
                <a
                  :href="item.zapPath"
                  target="_blank"
                  class="text-dark mb-3"
                  style="font-size: .9rem;"
                >
                  <i class="fa fa-whatsapp mr-2"></i>Maringá: (44) 3305-1980
                </a>
                <a :href="item.pathTo" target="_blank" class="text-dark" style="font-size: .9rem;">
                  <i class="fa fa-whatsapp mr-2"></i>Curitiba: (41) 3532-1509
                </a>
              </div>
            </div>
            <div class="mb-3">
              <a
                href="https://blog.vaapty.com/"
                target="_blank"
                class="text-uppercase text-yellow font-weight-normal"
                style="font-size: 135%;"
              >Blog</a>
            </div>
          </div>
        </div>
        <!-- close -->
      </b-row>
    </b-container>
  </section>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  directives: {
    ClickOutside,
  },
  data: () => {
    return {
      lgLogo: "2",
      mdLogo: "4",
      colsLogo: "4",
      isOpen: false,
      fontSizeMenu: "",
      heightMenu: "",
      widthLogo: 200,
      menu: [
        {
          id_t: 3,
          title: "quem somos",
          pathTo: "/quem-somos",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "",
        },
        {
          id_t: 4,
          title: "como funciona",
          pathTo: "/como-funciona",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "",
        },
        {
          id_t: 5,
          title: "seja um franqueado",
          pathTo: "/seja-um-franqueado",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "",
        },
        {
          id_t: 6,
          title: "perguntas frequentes",
          pathTo: "/perguntas-frequentes",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "",
        },
        {
          id_t: 7,
          title: "contato",
          pathTo: "/contato",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "",
        },
        {
          id_t: 8,
          title: "sou lojista",
          pathTo: "/sou-lojista",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "",
        },
        // High device
        {
          id_t: 9,
          title:
            '<i class="fab fa-whatsapp mr-2"></i><strong class="ml-2" style="font-size: 1.2rem;">Fale com um consultor</strong>',
          pathTo: "https://wa.me/554135321509",
          zapPath: "https://wa.me/554433051980",
          route: false,
          disabled: false,
          styleButton: "",
          controlBox: "d-none",
        },
        // Mobile
        {
          id_t: 1,
          title:
            '<i class="fab fa-whatsapp mr-1"></i><strong>Fale com um consultor</strong>',
          pathTo: "https://wa.me/554135321509",
          zapPath: "https://wa.me/554433051980",
          route: true,
          disabled: true,
          styleButton: "",
          controlBox: "d-none",
        },

        {
          id_t: 11,
          title: "quero vender meu veículo",
          pathTo: "/vender-meu-carro",
          zapPath: "",
          route: true,
          disabled: true,
          styleButton: "bg-white text-purple",
          controlBox: "",
        },
      ],
      backdropControl: "d-none",
      countControl: 1,
    };
  },
  computed: {
    organizeMenu() {
      return this.menu.slice().sort((a, b) => {
        if (a.id_t > b.id_t) return 1;

        if (a.id_t < b.id_t) return -1;

        return 0;
      });
    },
  },
  methods: {
    hide() {
      if (this.countControl >= 2) {
        this.closeAnimateBox();
        this.countControl = 1;
      } else {
        this.countControl++;
      }
    },
    closeAnimateBox() {
      this.menu.forEach((e) => (e.controlBox = "d-none"));
      this.backdropControl = "d-none";
    },
    animateBox(refId) {
      this.backdropControl =
        this.backdropControl === "d-none" ? "d-inline-block" : "d-none";

      this.menu[refId].controlBox =
        this.menu[refId].controlBox === "d-none" ? "d-flex flash" : "d-none";

      this.menu.forEach((e, i) => {
        if (refId !== i) e.controlBox = "d-none";
      });
    },
    animateBoxMobile(refId) {
      this.menu.forEach((e) => {
        if (e.id_t === refId) {
          e.controlBox = e.controlBox === "d-none" ? "d-flex flash" : "d-none";
        } else {
          e.controlBox = "d-none";
        }
      });
    },
    handleScroll() {
      let menuSelector = document.querySelector("#yellow-header");
      let containerMenuBurguer = document.querySelector(".container-nav-icon");
      let offSet = menuSelector.offsetTop;

      if (window.scrollY > offSet) {
        // alterando as propriedades do menu
        // position
        menuSelector.classList.add("position-fixed");
        menuSelector.classList.add("shadow-lg");
        menuSelector.setAttribute("style", "top: 0; left: 0; z-index: 4;");

        // height
        // containerMenuBurguer.classList.add('py-2')
        menuSelector.classList.remove("py-4");

        // alterando propriedades do vue
        this.widthLogo = 200;
        this.heightMenu = "py-4";

        this.menu[this.menu.length - 1].disabled = false;
      } else {
        // removo minhas alterações
        menuSelector.classList.remove("position-fixed");
        menuSelector.classList.remove("shadow-lg");
        menuSelector.removeAttribute("style");

        // retornando alterações que eu removi
        // menuSelector.classList.add('py-4')
        containerMenuBurguer.classList.remove("py-4");

        // alterando propriedades do vue
        this.widthLogo = 200;
        this.heightMenu = "";
        this.fontSizeMenu = "";

        this.menu[this.menu.length - 1].disabled = true;
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@mixin transitionMixin($transition-time) {
  transition: $transition-time + s ease !important;
  -moz-transition: $transition-time + s all ease !important;
  -o-transition: $transition-time + s all ease !important;
  -webkit-transition: $transition-time + s all ease !important;
}

section {
  @include transitionMixin(0.1);
  height: 80px;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    height: 65px;
  }
}

$break-point-menu: "991px";

.menu-links {
  color: rgba(255, 255, 255, 1);
  font-size: 85%;
}
.menu-links-important {
  color: rgba(255, 255, 255, 1) !important;
  font-size: 85%;
}

#menu-high-device {
  @media screen and (max-width: #{$break-point-menu}) {
    display: none !important;
  }
}

#menu-low-device {
  display: none;
  @media screen and (max-width: #{$break-point-menu}) {
    display: flex;
  }
}

// menu setts
@import "../scss/_menu/menu";
.container-menu-low-device {
  position: fixed;
  top: 0px;
  right: 0vw;
  width: 100vw;
  height: 100vh;
  z-index: 4;
  transform: translateX(-100vw) !important;
  @include transitionMixin(0.1);

  @media screen and (min-width: #{$break-point-menu}) {
    display: none !important;
  }
}

.p-left-0 {
  transform: translateX(0) !important;
}

.z-index-icon {
  z-index: 5;
}
</style>
